(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 881:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(8923);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./lib/classNames.ts
var classNames = __webpack_require__(9413);
// EXTERNAL MODULE: ./components/PostCard.tsx
var PostCard = __webpack_require__(5745);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/BlurImage.tsx
var BlurImage = __webpack_require__(1166);
;// CONCATENATED MODULE: ./components/PostListing.tsx



var PostListing = function(param) {
    var post = param.post;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/" + post.categories.map(function(category) {
            return category.seo.slug;
        }).join("/") + "/" + post.seo.slug,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bg-white cursor-pointer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto max-w-7xl sm:px-2 lg:px-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-2xl px-4 mx-auto lg:max-w-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-5 space-y-16",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col lg:grid lg:grid-cols-12 lg:gap-x-8 lg:items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-auto lg:col-span-5 xl:col-span-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "overflow-hidden bg-gray-100 rounded-lg aspect-w-5 aspect-h-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                                            src: ((ref = post.image) === null || ref === void 0 ? void 0 : ref.url) || "/logo-with-background.png",
                                            alt: post.imageAlt || post.title,
                                            className: "object-cover object-center rounded-xl",
                                            fill: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-6 lg:mt-0 lg:col-span-7 xl:col-span-7",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-lg font-medium text-gray-900",
                                            children: post.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-2 text-sm text-gray-500",
                                            children: post.description
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var components_PostListing = (PostListing);

;// CONCATENATED MODULE: ./components/Category.tsx





var Category = function(param) {
    var category = param.category, posts = param.posts, treatments = param.treatments;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative py-12 overflow-hidden ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative px-4 sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto text-lg max-w-prose",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "block mt-2 text-3xl font-extrabold leading-8 tracking-tight text-center text-gray-900 sm:text-4xl",
                                children: category.name
                            }),
                            category.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-8 text-xl leading-8 text-gray-500",
                                children: category.description
                            })
                        ]
                    })
                })
            }),
            treatments.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative px-4 pt-4 pb-20 bg-gray-50 sm:px-6 lg:pt-14 lg:pb-28 lg:px-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative mx-auto max-w-7xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,classNames/* default */.Z)(treatments.length < 3 ? "lg:grid-cols-2" : "lg:grid-cols-3", "grid max-w-lg gap-5 mx-auto mt-12 lg:max-w-none"),
                        children: treatments.map(function(_param) /*#__PURE__*/ {
                            var __typename = _param.__typename, treatment = (0,_object_without_properties/* default */.Z)(_param, [
                                "__typename"
                            ]);
                            return (0,jsx_runtime.jsx)(PostCard/* default */.Z, {
                                post: treatment
                            }, treatment.id);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-4 mx-auto max-w-7xl sm:px-6 lg:px-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative z-10 flex items-baseline justify-between pt-12 pb-6 border-b border-gray-200",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "mx-auto text-4xl font-extrabold tracking-tight text-center text-gray-900",
                                children: [
                                    category.name,
                                    " Articles"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            "aria-labelledby": "posts",
                            className: "pt-6 pb-24",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col",
                                children: posts.map(function(post) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PostListing, {
                                        post: post
                                    }, post.id);
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_Category = (Category);

// EXTERNAL MODULE: ./components/Layout.tsx + 6 modules
var Layout = __webpack_require__(7670);
// EXTERNAL MODULE: ./components/Page.tsx
var Page = __webpack_require__(6000);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./lib/baseUrl.ts
var baseUrl = __webpack_require__(9836);
// EXTERNAL MODULE: ./public/logo_with_background.png
var logo_with_background = __webpack_require__(222);
// EXTERNAL MODULE: ./components/RichTextRenderer.tsx
var RichTextRenderer = __webpack_require__(6205);
;// CONCATENATED MODULE: ./components/Post.tsx







var Post = function(props) {
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: props.seo.title || props.title || "",
                description: props.seo.description || props.description || "",
                noindex: props.seo.noIndex,
                openGraph: {
                    title: props.seo.title || props.title,
                    description: props.seo.description || props.description || "",
                    url: baseUrl/* default */.Z + router.pathname,
                    type: "article",
                    article: {
                        publishedTime: props.publishedAt,
                        modifiedTime: props.updatedAt,
                        section: props.categories[0].name,
                        tags: props.tags
                    },
                    images: [
                        {
                            url: ((ref = props.image) === null || ref === void 0 ? void 0 : ref.url) || "/logo_with_background.png",
                            alt: props.imageAlt || props.title
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* ArticleJsonLd */.dX, {
                url: baseUrl/* default */.Z + router.pathname,
                title: props.seo.title || props.title,
                description: props.seo.description || props.description || "",
                images: [
                    ((ref1 = props.image) === null || ref1 === void 0 ? void 0 : ref1.url) || "/logo_with_background.png"
                ],
                datePublished: props.publishedAt,
                dateModified: props.updatedAt,
                publisherName: "Welfare Abroad",
                publisherLogo: baseUrl/* default */.Z + "/logo.png",
                authorName: [
                    {
                        "@type": "Organization",
                        name: "Welfare Abroad"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-4 py-16 mx-auto max-w-7xl sm:py-24 sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl",
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "max-w-xl mx-auto mt-5 text-xl text-gray-500",
                                children: props.description
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mx-auto max-w-7xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "aspect-w-16 aspect-h-9",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                        src: ((ref2 = props.image) === null || ref2 === void 0 ? void 0 : ref2.url) || logo_with_background/* default */.Z,
                        alt: props.imageAlt || props.title,
                        className: "object-cover",
                        fill: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative py-16 overflow-hidden bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative px-4 sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto mt-6 prose prose-lg text-gray-500 prose-green",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* default */.Z, {
                            content: (ref3 = props.content) === null || ref3 === void 0 ? void 0 : ref3.json
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_Post = (Post);

// EXTERNAL MODULE: ./components/ComponentSwitch.tsx + 11 modules
var ComponentSwitch = __webpack_require__(6815);
;// CONCATENATED MODULE: ./components/Treatment.tsx



var Treatment = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: props.seo.title || props.title || "",
                description: props.seo.description || props.description || "",
                noindex: props.seo.noIndex,
                openGraph: {
                    title: props.seo.title || props.title || "",
                    description: props.seo.description || props.description || ""
                }
            }),
            props.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative py-12 overflow-hidden bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative px-4 sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto text-lg max-w-prose",
                        children: [
                            props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "block mt-2 text-3xl font-extrabold leading-8 tracking-tight text-center text-gray-900 sm:text-4xl",
                                    children: props.title
                                })
                            }),
                            props.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-8 text-xl leading-8 text-gray-500",
                                children: props.description
                            })
                        ]
                    })
                })
            }),
            props.components && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentSwitch/* default */.Z, {
                components: props.components
            })
        ]
    });
};
/* harmony default export */ var components_Treatment = (Treatment);

;// CONCATENATED MODULE: ./pages/[...slug].tsx









var CatchAll = function(_param) {
    var data = _param.data, preview = _param.preview, commonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "data",
        "preview"
    ]);
    var renderSwitch = function(data) {
        switch(data.__typename){
            case "Page":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
                    page: data
                });
            case "Post":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Post, (0,_object_spread/* default */.Z)({}, data));
            case "Treatment":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Treatment, (0,_object_spread/* default */.Z)({}, data));
            case "Category":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Category, {
                    category: data,
                    posts: data.posts,
                    treatments: data.treatments
                });
            default:
                return;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        preview: preview
    }, commonProps), {
        children: renderSwitch(data)
    }));
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (CatchAll);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [77,308,541,0,774,888,179], function() { return __webpack_exec__(881); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);